var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcCloseLarge = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 1.959,
  height: 20.565,
  rx: 0.979,
  transform: "scale(.99538 1.0046)rotate(45 4.547 24.573)"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 1.959,
  height: 20.565,
  rx: 0.979,
  transform: "scale(.99538 1.0046)rotate(-45 8.487 -2.168)"
})));
export default SvgIcCloseLarge;